import React, { useState, useEffect, useRef } from "react";

export default function CoffeeSequence({ className }) {
  const [frame, setFrame] = useState(1);
  const totalFrames = 51;
  const timerRef = useRef(null);

  useEffect(() => {
    // Preload images
    for (let i = 1; i <= totalFrames; i++) {
      const img = new Image();
      img.src = `/assets/coffee-sequence/ezgif-frame-${String(i).padStart(3, "0")}.jpg`;
    }

    // Play animation
    const play = () => {
      setFrame((prev) => (prev >= totalFrames ? 1 : prev + 1));
      timerRef.current = setTimeout(play, 120); // Slower speed (~8fps)
    };

    play();

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  const currentFrameUrl = `/assets/coffee-sequence/ezgif-frame-${String(frame).padStart(3, "0")}.jpg`;

  return (
    <div className={`relative overflow-hidden ${className}`}>
      <img
        src={currentFrameUrl}
        alt="Coffee Animation"
        className="absolute inset-0 w-full h-full object-cover"
      />
    </div>
  );
}
